import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { forceClearAuth, isAccessTokenValid, isAuthenticated } from '../utils/auth';
import { refreshToken as backendRefreshToken } from '../utils/refreshToken';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [status, setStatus] = useState<'checking' | 'allowed' | 'redirect'>('checking');

  useEffect(() => {
    const run = async () => {
      if (!isAuthenticated()) {
        setStatus('redirect');
        return;
      }

      // Access token still good — allow immediately
      if (isAccessTokenValid()) {
        setStatus('allowed');
        return;
      }

      // Access expired but refresh token exists — renew before allowing
      const currentRefreshToken = localStorage.getItem('refresh_token');
      if (!currentRefreshToken) {
        forceClearAuth();
        setStatus('redirect');
        return;
      }

      try {
        const data = await backendRefreshToken(currentRefreshToken);
        const newAccess = data.access_token || data.accessToken || data.token;
        const newRefresh = data.refresh_token || data.refreshToken;
        if (newAccess) localStorage.setItem('access_token', newAccess);
        if (newRefresh) localStorage.setItem('refresh_token', newRefresh);
        setStatus('allowed');
      } catch {
        forceClearAuth();
        setStatus('redirect');
      }
    };
    run();
  }, []);

  if (status === 'checking') return null;
  if (status === 'redirect') return <Navigate to="/login" replace />;

  return <>{children}</>;
};

export default ProtectedRoute;
